/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/eye': {
    width: 28,
    height: 22,
    viewBox: '0 0 28 22',
    data: '<path pid="0" d="M16.506 13.515a3.545 3.545 0 11-5.011-5.011M11.5 8.49a3.546 3.546 0 115.01 5.01" _fill="#C4C4C4"/><path pid="1" d="M16.506 13.515a3.545 3.545 0 11-5.011-5.011m.005-.015a3.546 3.546 0 115.01 5.011m4.51 4.53A11.9 11.9 0 0114 20.463c-8.273 0-13-9.455-13-9.455a21.804 21.804 0 015.98-7.02c1.43-1.104 2.494-1.517 4.538-2.15 0 0 1.646-.286 2.482-.284 8.273 0 13 9.454 13 9.454a21.867 21.867 0 01-2.553 3.77c-1.193 1.413-1.955 2.113-3.427 3.25z" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
